import { merge } from '../../helper';

import exLanguage from '../../language';

import * as exModal from './modal';
import type { IModalConfig } from './types';

// ----------------------------------------------------------------------------

export interface IModalValidation extends IModalConfig {
    type?: string;
    title?: string;
    message?: string;
    textAction?: string;
    classAction?: string;
    fnAction?: any;
}

// ----------------------------------------------------------------------------

function validation(config: IModalValidation = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        modalHeader: {
            type: config.type ?? 'success',
            title: {
                html: config.title,
            },
        },
        modalBody: {
            html: config.message,
        },
        buttons: [
            {
                html: config.textAction ?? exLanguage.line('general.ok'),
                class: {
                    new: config.classAction ?? 'btn btn-secondary',
                },
                fnAction: config.fnAction,
            },
        ],
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // If there is no icon
    if (defConfig.modalHeader.icon == null) {
        switch (defConfig.modalHeader.type) {
            case 'success':
                defConfig.modalHeader.icon = 'fa-solid fa-check';
                break;
            case 'warning':
                defConfig.modalHeader.icon = 'fa-solid fa-exclamation';
                break;
            case 'danger':
                defConfig.modalHeader.icon = 'fa-solid fa-exclamation';
                break;
            // No default
        }
    }

    // If there is no title
    if (defConfig.modalHeader.title.html == null) {
        switch (defConfig.modalHeader.type) {
            case 'success':
                defConfig.modalHeader.title.html = exLanguage.line('general.success');
                break;
            case 'warning':
                defConfig.modalHeader.title.html = exLanguage.line('general.warning');
                break;
            case 'danger':
                defConfig.modalHeader.title.html = exLanguage.line('general.danger');
                break;
            // No default
        }
    }

    // If there is no modal body html
    if (defConfig.modalBody.html == null) {
        switch (defConfig.modalHeader.type) {
            case 'success':
                defConfig.modalBody.html = exLanguage.line('exception.complete_request');
                break;
            case 'warning':
                defConfig.modalBody.html = exLanguage.line('exception.could_not_complete_request');
                break;
            case 'danger':
                defConfig.modalBody.html = exLanguage.line('exception.could_not_complete_request');
                break;
            // No default
        }
    }

    // ------------------------------------------------------------------------

    // Create element (modal)
    const modal = exModal.start({
        merge: defConfig,
        destroy: true,
    });

    // ------------------------------------------------------------------------

    // Return
    return modal;
}

// ----------------------------------------------------------------------------

export default validation;
